<mat-dialog-content>
  <lemon-dialog-header>
    {{ 'tositteet.laskujen-hyvaksyminen-estetty-dialog.otsikko' | translate | async }}
  </lemon-dialog-header>

  <div class="tosite-tiedot">
    {{ 'tositteet.laskujen-hyvaksyminen-estetty-dialog.leipateksti' | translate | async }}
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0">
  <button class="secondarybutton" mat-button cdkFocusRegionstart mat-dialog-close>{{ 'yleiset.peruuta' | translate | async }}</button>
  <span style="display: inline-block; width: 8vw; max-width: 4em"></span>
  <button class="primarybutton" mat-button (click)="maksettu()">{{ 'tositteet.laskujen-hyvaksyminen-estetty-dialog.merkitse-maksetuksi' | translate | async }}</button>
</mat-dialog-actions>
